// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2iCdU","content":"styles_content__2vYrI","selectAll":"styles_selectAll__19u3E"};